module.exports = __webpack_public_path__ + "img/ner_tagger_big.a2ae9042.svg";